import Vue from 'vue';

const pressingStart = 500;
const pressingDuration = 300;
const sparklesStart = pressingStart + pressingDuration;
const sparklesDuration = 1000;
const lineStart = sparklesStart + sparklesDuration;
const lineDuration = 1000;
const jiggleStart = lineStart;
const jiggleDuration = lineDuration;
const borderStart = lineStart + lineDuration;
const borderDuration = 600;
const tooltipStart = borderStart + borderDuration;
const tooltipDuration = 300;

export default {
  pressingStart,
  pressingDuration,
  sparklesStart,
  lineStart,
  lineDuration,
  jiggleStart,
  jiggleDuration,
  borderStart,
  tooltipStart,
  tooltipDuration,
};

export const animationsEventBus = new Vue();
